import { BillableEntitySource, FeatureTrack } from "@sp-crm/core";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ContentFull, ContentHeader } from "components/layout";
import { trpc } from "components/rpc/trpc";
import { Toggle } from "components/ui/toggle";
import React, { useCallback } from "react";
import { useRegionId } from "store/selectors/hooks";

export const RegionSettingsGeneral: React.FC<unknown> = () => {
    const trpcClient = trpc.useTRPC();
    const regionId = useRegionId();

    const { data: regionFeatureTrack, refetch: refetchRegionFeatureTrack } = useQuery(
        trpcClient.feature.getRegionFeatureTrack.queryOptions({ regionId }),
    );

    const updateRegionFeatureTrackMutation = useMutation({
        ...trpcClient.feature.updateRegionFeatureTrack.mutationOptions(),
        onSuccess: () => {
            refetchRegionFeatureTrack();
        },
    });

    const handleUpdateRegionFeatureTrack = useCallback(
        (isChecked: boolean) => {
            updateRegionFeatureTrackMutation.mutate({
                regionId,
                featureTrack: isChecked ? FeatureTrack.Beta : FeatureTrack.Standard,
            });
        },
        [updateRegionFeatureTrackMutation, regionId],
    );

    if (regionFeatureTrack?.source !== BillableEntitySource.Explicit) {
        return null;
    }

    return (
        <div className="space-y-4 lg:space-y-8">
            <ContentFull>
                <ContentHeader>Features</ContentHeader>
                <div className="space-y-4 max-w-lg">
                    <div className="space-y-1 lg:space-y-2 group">
                        <Toggle
                            label="Enable early access features"
                            checked={
                                regionFeatureTrack.featureTrack === FeatureTrack.Beta
                            }
                            disabled={
                                regionFeatureTrack.source !==
                                BillableEntitySource.Explicit
                            }
                            onChange={handleUpdateRegionFeatureTrack}
                        />

                        <p className="text-gray-500 group-hover:text-gray-900 text-sm">
                            Get early access to new features before they are released!
                        </p>
                    </div>
                </div>
            </ContentFull>
        </div>
    );
};
